const styles = {
    typographyBody: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "1.5",
        letterSpacing: "0.15px",
        padding: "10px 0px",
    },
    boxPaddingBottom: {
        padding: "20px 0px 10px 0px",
    },
    formControlStyle: {
        "& .MuiFormControl-root": {
            paddingRight: "0px",
        },
    },
    footerCaption: {
        mt: "10px",
        mb: "20px",
        fontWeight: 400,
        lineHeight: "20px",
        fontSize: "12px",
        letterSpacing: "0.4px",
        color: "text.light",
    },
};

export default styles;
